// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "LazyIdentificationForm" + "." + "e8f37cebfb0c6fadca80" + ".css";
};